import { render, staticRenderFns } from "./reports-payment.vue?vue&type=template&id=3271e4fc&scoped=true"
import script from "./reports-payment.vue?vue&type=script&lang=js"
export * from "./reports-payment.vue?vue&type=script&lang=js"
import style0 from "./reports-payment.vue?vue&type=style&index=0&id=3271e4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3271e4fc",
  null
  
)

export default component.exports